import { type ReactNode } from 'react';

export type BarStripe = {
  position: number;
  variant: 'symbolic' | 'milestone';
  label?: string;
};

function stripeTitle(stripe: BarStripe): string | undefined {
  if (stripe.variant !== 'milestone' || !stripe.label) return undefined;
  return `Cambio de tarifa: ${stripe.label}`;
}

function MilestoneMarker({ stripe }: { stripe: BarStripe }): ReactNode {
  return (
    <div
      className="pointer-events-auto absolute -top-1 flex -translate-x-1/2 flex-col items-center"
      style={{ left: `${stripe.position * 100}%` }}
      title={stripeTitle(stripe)}
    >
      <div className="h-6 w-0.5 rounded-full bg-brand-red" />
      {stripe.label && (
        <span className="mt-1 whitespace-nowrap text-[10px] font-bold text-brand-red">
          {stripe.label}
        </span>
      )}
    </div>
  );
}

function SymbolicStripe({ stripe }: { stripe: BarStripe }): ReactNode {
  return (
    <div
      className="pointer-events-none absolute bottom-0 top-0 w-px bg-white/[0.15]"
      style={{ left: `${stripe.position * 100}%` }}
    />
  );
}

export function BarStripes({ stripes }: { stripes: BarStripe[] }): ReactNode {
  return (
    <>
      {stripes.map((s, i) =>
        s.variant === 'milestone' ? (
          <MilestoneMarker key={`${s.position}-${i}`} stripe={s} />
        ) : (
          <SymbolicStripe key={`${s.position}-${i}`} stripe={s} />
        )
      )}
    </>
  );
}
